import React from 'react';
import { InventoryLayout } from '../components/inventory/InventoryLayout';
export function TermsOfServicePage() {
  return <InventoryLayout data-id="element-654">
      {/* Page Header */}
      <div className="bg-navy-900 py-12 sm:py-16 border-b border-white/10" data-id="element-655">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-656">
          <div className="border-l-4 border-cg-orange-600 pl-6" data-id="element-657">
            <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-658">
              Terms of Service
            </h1>
          </div>
        </div>
      </div>

      <section className="bg-white py-16 sm:py-24" data-id="element-659">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg text-steel-600" data-id="element-660">
          <p data-id="element-661">Last updated: February 2025</p>
          <h3 data-id="element-662">1. Introduction</h3>
          <p data-id="element-663">
            These terms and conditions govern your use of the Chiltern Global
            Inventory System. By accessing this website, you accept these terms
            and conditions in full.
          </p>
          <h3 data-id="element-664">2. Intellectual Property Rights</h3>
          <p data-id="element-665">
            Unless otherwise stated, Chiltern Global Ltd and/or its licensors
            own the intellectual property rights in the website and material on
            the website. Subject to the license below, all these intellectual
            property rights are reserved.
          </p>
          <h3 data-id="element-666">3. License to Use Website</h3>
          <p data-id="element-667">
            You may view, download for caching purposes only, and print pages
            from the website for your own personal use, subject to the
            restrictions set out below and elsewhere in these terms and
            conditions.
          </p>
          <p data-id="element-668">You must not:</p>
          <ul data-id="element-669">
            <li data-id="element-670">
              Republish material from this website (including republication on
              another website).
            </li>
            <li data-id="element-671">Sell, rent or sub-license material from the website.</li>
            <li data-id="element-672">
              Reproduce, duplicate, copy or otherwise exploit material on this
              website for a commercial purpose.
            </li>
          </ul>
          <h3 data-id="element-673">4. Limitations of Liability</h3>
          <p data-id="element-674">
            Chiltern Global Ltd will not be liable to you (whether under the law
            of contact, the law of torts or otherwise) in relation to the
            contents of, or use of, or otherwise in connection with, this
            website for any direct, indirect, special or consequential loss.
          </p>
          <h3 data-id="element-675">5. Governing Law</h3>
          <p data-id="element-676">
            These terms and conditions will be governed by and construed in
            accordance with English law, and any disputes relating to these
            terms and conditions will be subject to the exclusive jurisdiction
            of the courts of England and Wales.
          </p>
        </div>
      </section>
    </InventoryLayout>;
}